/* eslint-disable import/prefer-default-export */
import * as lc from '../../../utils/lodashCustom';

export function restructureCommentModel(data) {
  return {
    id: lc.get(data, 'id'),
    parentId: lc.get(data, 'parent_id'),
    authorId: lc.get(data, 'author.id'),
    authorUserName: lc.get(data, 'author.username'),
    authorAvatarPath: lc.get(data, 'author_profile.avatar_path'),
    commentTitle: lc.get(data, 'comment_object.comment_title'),
    modelId: lc.get(data, 'model_id'),
    modelClass: lc.get(data, 'model_class'),
    like: lc.get(data, 'like'),
    content: lc.get(data, 'content'),
    createdAt: lc.get(data, 'created_at')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/restructuring/index.js